import { GxIcon } from './icon.js'



export class GxIconCircleMark extends GxIcon {

  constructor() {
    super()
    const temp = document.createElement("template")
    temp.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"  aria-hidden="true"><path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path></svg>
`
    super.addHTML(temp)
  }
}


if (!window.customElements.get("gx-icon-circlemark")) window.customElements.define("gx-icon-circlemark", GxIconCircleMark)
